/** Traductions lieu (petit déj, en-cas) : nom, description, prix par langue */
export const emptyVenueRestaurantTranslations = () => ({
  fr: { name: "", description: "", price: "" },
  en: { name: "", description: "", price: "" },
  ar: { name: "", description: "", price: "" },
})

export const createDefaultRestaurantFormData = () => ({
  name: "",
  description: "",
  price: "",
  image: null,
  reservable: true,
  translations: emptyVenueRestaurantTranslations(),
})

/**
 * À l’édition : remplit translations.*.price + price racine (FR) depuis l’API.
 */
export const normalizeVenueRestaurantFromApi = (restaurant) => {
  if (!restaurant || typeof restaurant !== "object") {
    return createDefaultRestaurantFormData()
  }
  const tr = restaurant.translations || {}
  const frName = tr.fr?.name ?? restaurant.name ?? ""
  const frDesc = tr.fr?.description ?? restaurant.description ?? ""
  const frPrice =
    tr.fr?.price != null && String(tr.fr.price).trim() !== ""
      ? String(tr.fr.price)
      : String(restaurant.price ?? "")
  return {
    name: frName,
    description: frDesc,
    price: restaurant.price != null && restaurant.price !== "" ? String(restaurant.price) : frPrice,
    image: null,
    reservable: restaurant.reservable,
    translations: {
      fr: {
        name: frName,
        description: frDesc,
        price: frPrice,
      },
      en: {
        name: tr.en?.name ?? "",
        description: tr.en?.description ?? "",
        price: tr.en?.price != null ? String(tr.en.price) : "",
      },
      ar: {
        name: tr.ar?.name ?? "",
        description: tr.ar?.description ?? "",
        price: tr.ar?.price != null ? String(tr.ar.price) : "",
      },
    },
  }
}

/** Avant envoi API : price racine = FR, objet translations complet */
export const prepareVenueRestaurantForSubmit = (data) => {
  const tr = data.translations || emptyVenueRestaurantTranslations()
  const frPrice = tr.fr?.price ?? data.price ?? ""
  return {
    price: frPrice,
    translations: {
      fr: { ...tr.fr, price: frPrice },
      en: { ...tr.en, price: tr.en?.price ?? "" },
      ar: { ...tr.ar, price: tr.ar?.price ?? "" },
    },
  }
}
